import React, { useState, useEffect } from "react";
import EmbedDynamicExample from "./EmbedDynamicExample.js";
import Icon from "components/Elements/Icon/Icon.tsx";
import Image from "components/Elements/Image/Image.tsx";
import CarouselFormsEdit from "./CarouselContainer/CarouselFormsEdit.js";
import { LinkToNewTab } from "components/Elements/Link/Link.js";
import { useUser } from "contexts/userContext/userContext.js";

const FormSide = ({
  pageMode,
  newSelectedListForm,
  selectedForm,
  setSelectedForm,
  hideBackButton,
  brandingColor,
  oldEmbedPageFormList,
  loadingCarousel,
  viewType,
  formImage,
  isUpdateTitleOrDescriptionForm,
  setIsUpdateTitleOrDescriptionForm,
  pageLanguage,
  backButtonText,
  countActiveForms,
  displayFormDetails,
}) => {
  const [selectedFormId, setSelectedFormId] = useState(null);
  const [activeForms, setActiveForms] = useState(countActiveForms);
  const selectedFormEmbedId = selectedForm?.Embed_Dynamic_Id;
  const [isFirstForm, setIsFirstForm] = useState(
    oldEmbedPageFormList.length > 1 &&
      oldEmbedPageFormList[0].EmbedPageFormId == selectedFormEmbedId
      ? true
      : false
  );
  useEffect(() => {
    const isFirst =
      oldEmbedPageFormList.length > 1 &&
      oldEmbedPageFormList[0].EmbedPageFormId == selectedFormEmbedId
        ? true
        : false;
    setIsFirstForm(isFirst);
  }, [selectedForm, oldEmbedPageFormList]);

  const { isPremium } = useUser();
  useEffect(() => {
    if (selectedFormId) {
      setSelectedForm(
        newSelectedListForm.filter(
          (item) => item.Embed_Dynamic_Id == selectedFormId
        )[0]
      );
    } else {
      setSelectedForm(null);
    }
  }, [selectedFormId]);

  const selectTheForm = (e) => {
    setSelectedFormId(e);
  };
  const resetForm = () => {
    setSelectedForm(null);
    setSelectedFormId(null);
  };
  useEffect(() => {
    if (newSelectedListForm && newSelectedListForm.length > 1) {
      if (!isUpdateTitleOrDescriptionForm) {
        resetForm();
      } else {
        setIsUpdateTitleOrDescriptionForm(false);
      }
    }
  }, [newSelectedListForm]);

  useEffect(() => {
    if (!selectedForm) {
      setSelectedFormId(null);
    }
  }, [selectedForm]);

  useEffect(() => {
    setActiveForms(countActiveForms);
  }, [countActiveForms]);

  return (
    <>
      <div className={`${selectedForm ? "tabletAndMobile" : "div-tablet"}`}>
        <div
          className={`${
            selectedForm ? "tabletAndMobile-div" : "div-tablet-div"
          } ${
            hideBackButton &&
            selectedForm &&
            (viewType === "tablet" || viewType === "mobile")
              ? "single-form"
              : ""
          }`}
        >
          {!hideBackButton && selectedForm && (
            <div
              className={`button-back-mobile ${
                !displayFormDetails && oldEmbedPageFormList.length > 1
                  ? "display-button"
                  : ""
              }`}
            >
              <div
                className="back-button back-button-tour-steps"
                onClick={() => resetForm()}
              >
                <Image title="" alt="" name="personal/back-forms" ext="png" />
                <span>{backButtonText}</span>
              </div>
            </div>
          )}
          {newSelectedListForm && selectedForm ? (
            <>
              {pageMode === "edit" && (
                <div
                  className={`edit-form ${
                    oldEmbedPageFormList.length === 1 ? "single-form" : ""
                  }`}
                >
                  <LinkToNewTab
                    isNewTab
                    page={`create-form/${selectedForm.Embed_Dynamic_Id}`}
                  >
                    <Icon name="pencil-alt-solid" />
                  </LinkToNewTab>
                </div>
              )}
              <EmbedDynamicExample
                activeFormInJumboFormsPage={
                  !isPremium() &&
                  activeForms > 1 &&
                  oldEmbedPageFormList.length > 1 &&
                  !isFirstForm
                    ? false
                    : true
                }
                embedPageFormImage={formImage}
                selectedForm={selectedForm}
                formInEmbedPage={true}
                hideFooter={true}
                embedPageEditMode={true}
                includeTitleAndDesc={
                  viewType !== "desktop" && pageMode === "preview"
                    ? true
                    : false
                }
                brandingColor={brandingColor}
                //previewMode={true}
              />
            </>
          ) : !loadingCarousel ? (
            <>
              <CarouselFormsEdit
                pageLanguage={pageLanguage}
                viewType={viewType}
                pageMode={pageMode}
                selectTheForm={selectTheForm}
                setFormSelected={setSelectedFormId}
                formList={oldEmbedPageFormList}
              />
            </>
          ) : (
            <div className="loading-personal loading-carousel">
              <Image
                className="loader-animation-gif"
                name="preloader"
                ext="gif"
                alt=""
                title=""
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default FormSide;
